import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { BehaviorSubject, catchError, of, tap } from 'rxjs';
import { GeocodeService } from 'src/app/core/services/geocode.service';
import { Address, PortalApiService, PropertySummary } from 'src/app/services/portal-api.service';
import { PlaceViewModel } from 'src/app/services/property.service';
import { GoogleMapsSearchAutocompleteSingleComponent } from 'src/app/shared/components/autocomplete/google-maps-search-autocomplete-single/google-maps-search-autocomplete.component';
import { MapComponent } from 'src/app/shared/components/map/map.component';
import { ProgressStepperComponent } from 'src/app/shared/components/progress-stepper/progress-stepper.component';
import { PropertyUploadNavigationComponent } from '../property-upload-navigation/property-upload-navigation.component';

export interface StepTwoData {
  data: {
    place: PlaceViewModel;
    encodedLocationBounds: string;
    placeMarker: PropertySummary[];
  };
  valid: boolean;
}

@Component({
  selector: 'app-step-two',
  standalone: true,
  templateUrl: './step-two.component.html',
  imports: [
    CommonModule,
    TranslocoDirective,
    ProgressStepperComponent,
    GoogleMapsSearchAutocompleteSingleComponent,
    MapComponent,
    PropertyUploadNavigationComponent,
  ],
})
export class StepTwoComponent implements OnInit {
  @Output() saveStepTwo = new EventEmitter<StepTwoData>();
  @Output() previousButtonClicked = new EventEmitter<void>();
  @Input() Steps: string[] = [];
  @Input() InitialLocation?:PlaceViewModel
  mapHasError:boolean = false;
  mapErrorMessage:string = '';
  place: PlaceViewModel | null = null;
  encodedLocationBounds: string | undefined;

  placeMarker: BehaviorSubject<PropertySummary[]> = new BehaviorSubject<
    PropertySummary[]
  >([]);

  constructor(private geocodeService: GeocodeService,private portalService:PortalApiService) {}

  ngOnInit(): void {
    if(this.InitialLocation)
      this.SelectedLocation(this.InitialLocation)
  }

  private validatePlaceSelection(){
    if(!this.place?.PostalCode || !this.place.StreetName || !this.place.StreetNumber){
      this.mapHasError = true;
      // # preciseLocation = Παρακαλώ επιλέξτε με ακριβεία την τοποθεσία του ακινήτου σας
      this.mapErrorMessage = 'preciseLocation'
      return false;
    }
    return true;
  }

  SelectedLocation(selectedPlace: PlaceViewModel) {
    this.place = selectedPlace;
    const encodedMessage = this.geocodeService.protoEncodeGeoSearch(selectedPlace);

    if(!this.validatePlaceSelection()){
      return;
    }

    this.portalService.postalCodeIsAllowed(selectedPlace?.PostalCode).pipe(
        tap(() => {
            console.log("Postal code validation successful.");
        }),
        catchError((error: any) => {
            this.mapHasError = true;
            // # serviceUnavailable = Η υπηρεσίας μας δεν είναι ακόμα διαθέσιμη στην περιοχή σου. Θα είμαστε όμως διαθέσιμοι πολύ σύντομα. 
            // # Για περισσοτερες πληροφορίες μην διστάσεις να επικοινωνήσεις μας στο info@uniko.gr
            this.mapErrorMessage = 'serviceUnavailable' 
            console.error("Error during postal code validation:", error);
            return of(error);
        })
    ).subscribe((errorResult) => {
        if (!errorResult) {
            this.mapHasError = false
            this.mapErrorMessage = ''
            this.encodedLocationBounds = btoa(String.fromCharCode(...encodedMessage));
            this.placeMarker.next([
                new PropertySummary({
                    address: new Address({
                        geoPoint: `${selectedPlace.Lat},${selectedPlace.Lon}`,
                    }),
                }),
            ]);
        }
    });
}

  saveStep() {
    this.saveStepTwo.emit({
      data: {
        place: this.place!,
        encodedLocationBounds: this.encodedLocationBounds!,
        placeMarker: this.placeMarker.value,
      },
      valid: !this.mapHasError,
    });
  }
}
